<!--
 * @Description: 
 * @Date: 2020-09-28 16:48:52
 * @LastEditors: jml
-->
<template>
  <div class="missBox">
    <img src="../img/common/2.png" />
    <p>活动暂未发布哟～</p>
    <van-button class="btn" block type="info" @click="toGameList">知道了</van-button>
  </div>
</template>

<script>
export default {
  methods: {
    toGameList() {
      this.$router.push({
        name: 'game'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.missBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: #fff;
  margin-top: 0;
  z-index: 10;
  padding-top: 2.5rem;
  & > img {
    width: 3.5rem;
    height: 3.5rem;
  }
  .btn {
    width: 4.8rem;
    height: 1.28rem;
    border-radius: 0.21rem;
    margin: 0 auto;
    margin-top: 1.5rem;
  }
}
</style>